export const contractAddress =
  'erd1qqqqqqqqqqqqqpgqrrccfuyx3hmdpyg330cnf8r93qc8g67zwmfs7l8qsq';
export const token = 'ESTAR-afaaf0';
export const microservice = 'https://equistar.estar.games:1212';
export const newTokenIdentifier = 'ESTAR-461bab';

export const dAppName = 'Estar Games';
